const types={
  GET_MODERATORS_LIST:'GET_MODERATORS_LIST',
  GET_MODERATOR_ITEM:'GET_MODERATOR_ITEM',
  CLEAR_MODERATOR_ITEM:'CLEAR_MODERATOR_ITEM',
  ERROR_INFO_ITEM:'ERROR_INFO_ITEM',
}

export default types